import type { FC } from "react"
import { useState } from "react"

import { useAddNoteToDesignRequest } from "~/containers/Proposal/state/design-request/use-design-request"
import { useProposalActions } from "~/containers/Proposal/state/proposal/proposal-context"
import type { Design } from "~/graphql/client"

import { ReactComponent as XIcon } from "@svg/x.svg"

import { Buttons, CharsLeft, Header, Info, Wrapper } from "./styles"

export const AddComment: FC<{
  close: VoidFunction
  design?: Design
}> = ({ close, design }) => {
  const [comment, setComment] = useState<string>(``)
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length <= 255) setComment(e.target.value)
  }
  const { addNote, mutation } = useAddNoteToDesignRequest()
  const { refetch } = useProposalActions()
  const handleSave = async () => {
    if (comment.length === 0 || !design?.designRequest?.id) return
    await addNote(design.designRequest.id, comment)
    await refetch()
    close()
  }

  return (
    <Wrapper isSaving={mutation.isLoading}>
      <Header>
        <h1>Add Comment</h1>
        <XIcon onClick={close} />
      </Header>
      <textarea value={comment} onChange={handleChange} />
      <Info>
        <p>The maximum allowed number of characters is 255</p>
        <CharsLeft>{255 - comment.length} left</CharsLeft>
      </Info>
      <Buttons>
        <button onClick={handleSave}>add comment</button>
        <button onClick={close}>Cancel</button>
      </Buttons>
    </Wrapper>
  )
}
